<a [class]="item.selected ? 'mat-list-nav-item active': 'mat-list-nav-item'" *ngIf="!item.disabled" mat-list-item
   [ngStyle]="{'padding-left': (depth * 12) + 'px'}" (click)="onItemSelected(item)"
   [ngClass]="{'active': item.route ? router.isActive(item.route, true): false, 'expanded': expanded}"
   class="menu-list-item">
  <mat-icon class="routeIcon">{{item.iconName}}</mat-icon>
  {{item.displayName}} <span *ngIf="item.navLandName !== undefined">({{item.navLandName}})</span>
  <span fxFlex *ngIf="item.children && item.children.length">
    <span fxFlex></span>
    <mat-icon class="expandIcon" *ngIf="!expanded">
      expand_more
    </mat-icon>
    <mat-icon class="expandIcon" *ngIf="expanded">
      expand_less
    </mat-icon>
  </span>
</a>
<div *ngIf="expanded">
  <app-nav-list-item *ngFor="let child of item.children" [item]="child" [depth]="depth+1">
  </app-nav-list-item>
</div>
